/* FINAL HAMMER v2 rotator (2026-09-16).
 * Job: keep the deal section truthful on a stale client, with the shape Last Bottle ships
 * (visibility check throttled 30s, a bounded number of in-place swaps then a budgeted reload,
 * a preflight before purchase, verification after add-to-cart).
 *  - Validates on load (a first render can be a cached one), then polls the section itself via
 *    the Section Rendering API while the tab is visible (interval from data-fh-poll), and on
 *    visibilitychange / pageshow / online (throttled), and the instant a countdown hits zero.
 *  - Swaps the section in place when data-fh-rev differs (every material offer field is in it).
 *    One request in flight at a time; failures back off; after 6 swaps a reload guarded by a
 *    sessionStorage budget (2 reloads, 8s cooldown, 60s TTL).
 *  - PURCHASE is the theme's own product-form (cart drawer, analytics, error display). Before the
 *    add, the section is re-fetched: if the deal changed, no add. On the theme's add error the
 *    variant is re-read: sold out -> "Gone." + swap; still available -> quantity limit, button
 *    restored. After a successful add the section is re-verified on a short schedule.
 */
(function () {
  "use strict";
  var root = document.querySelector("[data-fh-section]");
  if (!root) return;

  var GUARD_KEY = "bhw:fh-reload-guard";
  var MAX_SWAPS = 6, MAX_RELOADS = 2, RELOAD_COOLDOWN_MS = 8000, BUDGET_TTL_MS = 60000, THROTTLE_MS = 30000;
  var VERIFY_SCHEDULE_MS = [400, 1200, 2500, 4500];
  var swaps = 0, inflight = null, lastCheck = 0, failures = 0, nextAllowed = 0, zeroFired = false;
  var log = [];

  function note(kind, extra) {
    log.push({ t: Date.now(), kind: kind, extra: extra || null });
    if (log.length > 60) log.shift();
  }
  function guard() {
    try {
      var g = JSON.parse(sessionStorage.getItem(GUARD_KEY) || "{}");
      if (!g.t || Date.now() - g.t > BUDGET_TTL_MS) g = { t: Date.now(), reloads: 0, last: 0 };
      return g;
    } catch (e) { return { t: Date.now(), reloads: 0, last: 0 }; }
  }
  function saveGuard(g) { try { sessionStorage.setItem(GUARD_KEY, JSON.stringify(g)); } catch (e) {} }

  function sectionUrl() {
    var u = new URL(window.location.href);
    u.searchParams.set("section_id", root.getAttribute("data-fh-section"));
    u.searchParams.set("_", Date.now().toString(36));
    u.hash = "";
    return u.pathname + u.search;
  }

  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function fmtClock(s) {
    var d = Math.floor(s / 86400), r = s % 86400;
    var t = pad(Math.floor(r / 3600)) + ":" + pad(Math.floor(r / 60) % 60) + ":" + pad(r % 60);
    return d > 0 ? d + "d " + t : t;
  }
  function nowS() { return Math.floor(Date.now() / 1000); }
  var resetMode = false;
  /* seconds until the next daily reset at hour H in Pacific time (DST-safe via Intl); 1..86400 */
  function toReset(H) {
    var parts = {}; new Intl.DateTimeFormat("en-US", { timeZone: "America/Los_Angeles", hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit" })
      .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    var sod = (parseInt(parts.hour, 10) % 24) * 3600 + parseInt(parts.minute, 10) * 60 + parseInt(parts.second, 10);
    var t = (H * 3600 - sod) % 86400; if (t <= 0) t += 86400;
    return t;
  }

  function tick() {
    var until = root.querySelector("[data-fh-until]"), val = root.querySelector("[data-fh-ends]");
    if (until && val) {
      var end = parseInt(until.getAttribute("data-fh-until"), 10);
      var rh = until.getAttribute("data-fh-reset-hour");
      if (end > 0) {
        var s = Math.max(0, end - nowS());
        if (rh !== null && rh !== "") { var r = toReset(parseInt(rh, 10)); if (r < s) { s = r; resetMode = true; } else { resetMode = false; } }
        val.textContent = fmtClock(s);
        var dd = until.querySelector("[data-fh-cd-d]"), hh = until.querySelector("[data-fh-cd-h]"), mm = until.querySelector("[data-fh-cd-m]"), ss = until.querySelector("[data-fh-cd-s]");
        var days = Math.floor(s / 86400);
        if (dd) { dd.textContent = days; var dc = dd.parentNode; if (dc) dc.classList.toggle("is-zero", days === 0); }
        if (hh) hh.textContent = pad(dd ? Math.floor(s / 3600) % 24 : Math.floor(s / 3600));
        if (mm) mm.textContent = pad(Math.floor(s / 60) % 60);
        if (ss) { ss.textContent = pad(s % 60); ss.classList.remove("is-tick"); void ss.offsetWidth; ss.classList.add("is-tick"); }
        if (s === 0 && !resetMode && !zeroFired) { zeroFired = true; check("deadline", true); }
      }
    }
    var cd = root.querySelector("[data-fh-countdown]");
    if (cd) {
      var t = Math.max(0, parseInt(cd.getAttribute("data-fh-countdown"), 10) - nowS());
      var d = cd.querySelector("[data-fh-d]"), h = cd.querySelector("[data-fh-h]"), m = cd.querySelector("[data-fh-m]"), sc = cd.querySelector("[data-fh-s]");
      if (d) d.textContent = Math.floor(t / 86400);
      if (h) h.textContent = pad(Math.floor(t / 3600) % 24);
      if (m) m.textContent = pad(Math.floor(t / 60) % 60);
      if (sc) sc.textContent = pad(t % 60);
      if (t === 0 && !zeroFired) { zeroFired = true; check("release", true); }
    }
  }
  setInterval(tick, 1000); tick();

  function replaceRoot(fresh) {
    var oldHandle = root.getAttribute("data-fh-handle");
    var qty = root.querySelector("[data-fh-qty]"), qtyVal = qty ? qty.value : null;
    var hadFocus = root.contains(document.activeElement);
    root.replaceWith(fresh);
    root = fresh;
    zeroFired = false;
    if (qtyVal && root.getAttribute("data-fh-handle") === oldHandle) {
      var q2 = root.querySelector("[data-fh-qty]"); if (q2) q2.value = qtyVal;
    }
    if (hadFocus) { var b = root.querySelector("[data-fh-buy]"); if (b) { try { b.focus({ preventScroll: true }); } catch (e) {} } }
    wire(); tick();
    note("swap", { from: oldHandle, to: root.getAttribute("data-fh-handle") });
    document.dispatchEvent(new CustomEvent("fh:swapped", { detail: { from: oldHandle, handle: root.getAttribute("data-fh-handle"), rev: root.getAttribute("data-fh-rev") } }));
  }

  function hardReload() {
    var g = guard();
    if (g.reloads >= MAX_RELOADS) { note("reload-budget-spent"); console.warn("FH rotator: reload budget spent, leaving the page alone"); return; }
    if (Date.now() - g.last < RELOAD_COOLDOWN_MS) return;
    g.reloads++; g.last = Date.now(); saveGuard(g);
    note("reload");
    window.location.reload();
  }

  function check(reason, force) {
    if (inflight) return inflight;
    var now = Date.now();
    if (!force && (document.hidden || now < nextAllowed)) return Promise.resolve(false);
    lastCheck = now;
    note("check", reason);
    inflight = fetch(sectionUrl(), { cache: "no-store", credentials: "same-origin", headers: { "Accept": "text/html" } })
      .then(function (r) { if (!r.ok) throw new Error("sra " + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("[data-fh-section]");
        if (!fresh) throw new Error("sra-empty");
        failures = 0; nextAllowed = 0;
        if (fresh.getAttribute("data-fh-rev") === root.getAttribute("data-fh-rev")) {
          // same offer: keep the live stock count honest without re-rendering the section
          var pairs = [["[data-fh-stock]", "data-fh-stock"], ["[data-fh-progress]", "data-fh-progress"]];
          for (var pi = 0; pi < pairs.length; pi++) {
            var fs = fresh.querySelector(pairs[pi][0]), cs = root.querySelector(pairs[pi][0]);
            if (fs && cs) { if (fs.getAttribute(pairs[pi][1]) !== cs.getAttribute(pairs[pi][1])) { cs.replaceWith(fs); note("live-patch", pairs[pi][1]); } }
            else if (fs || cs) { swaps++; if (swaps > MAX_SWAPS) { hardReload(); return true; } replaceRoot(fresh); return true; }
          }
          return false;
        }
        swaps++;
        if (swaps > MAX_SWAPS) { hardReload(); return true; }
        replaceRoot(fresh);
        return true;
      })
      .catch(function (err) {
        failures++;
        nextAllowed = Date.now() + Math.min(60000, 2000 * Math.pow(2, failures - 1));
        note("check-failed", String(err && err.message));
        return false;
      })
      .then(function (v) { inflight = null; return v; });
    return inflight;
  }
  function throttledCheck(reason) { if (Date.now() - lastCheck < THROTTLE_MS) return; check(reason, false); }

  function showGone() { var tl = root.querySelector("[data-fh-toolate]"); if (tl) tl.classList.add("show"); }

  function onAddError(e) {
    var handle = root.getAttribute("data-fh-handle"), vid = root.getAttribute("data-fh-variant");
    if (!handle) return;
    fetch("/products/" + handle + ".js", { cache: "no-store" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var v = null;
        if (p && p.variants) { for (var i = 0; i < p.variants.length; i++) { if (String(p.variants[i].id) === String(vid)) v = p.variants[i]; } }
        if (!p || !v || !v.available) {
          note("add-error-gone");
          showGone();
          setTimeout(function () { check("gone", true); }, 900);
          return;
        }
        // Still available: the add failed on quantity. Keep the theme's message, restore the button, clamp the quantity if the message named one.
        note("add-error-qty");
        var btn = root.querySelector("[data-fh-buy]");
        if (btn) {
          btn.removeAttribute("aria-disabled");
          var t = btn.querySelector("[data-sold-out]");
          if (t) t.textContent = t.getAttribute("data-fh-label") || "Purchase";
        }
        var msg = (e && e.detail && e.detail.errorMessage) || "";
        var m = String(msg).match(/(\d+)/), qty = root.querySelector("[data-fh-qty]");
        if (m && qty && parseInt(m[1], 10) > 0) qty.value = m[1];
      })
      .catch(function () {});
  }
  function onAdded() {
    note("added");
    VERIFY_SCHEDULE_MS.forEach(function (ms) { setTimeout(function () { check("post-add", true); }, ms); });
  }
  document.addEventListener("ajaxProduct:error", onAddError);
  document.addEventListener("ajaxProduct:added", onAdded);

  // Preflight: a submit on the deal form first re-fetches the section. If the deal changed under the
  // shopper, the swap happens and the add does not. The theme's own product-form handles the add.
  var lastSubmit = 0;
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute("data-fh-form")) return;
    if (form.getAttribute("data-fh-preflighted") === "1") { form.removeAttribute("data-fh-preflighted"); lastSubmit = Date.now(); return; }
    e.preventDefault(); e.stopPropagation();
    if (Date.now() - lastSubmit < 1500) { note("submit-debounced"); return; }
    var btn = form.querySelector("[data-fh-buy]");
    if (btn) btn.setAttribute("aria-busy", "true");
    var before = root.getAttribute("data-fh-rev");
    check("preflight", true).then(function () {
      if (btn) btn.removeAttribute("aria-busy");
      if (root.getAttribute("data-fh-rev") !== before) { note("preflight-changed"); return; }
      var f2 = root.querySelector("[data-fh-form]");
      if (!f2) return;
      f2.setAttribute("data-fh-preflighted", "1");
      if (typeof f2.requestSubmit === "function") f2.requestSubmit(); else f2.submit();
    });
  }, true);

  function wire() {
    var qty = root.querySelector("[data-fh-qty]"), minus = root.querySelector("[data-fh-qminus]"), plus = root.querySelector("[data-fh-qplus]");
    if (minus && qty) minus.addEventListener("click", function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    if (plus && qty) plus.addEventListener("click", function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
  }
  wire();

  function schedulePoll() {
    var ms = parseInt(root.getAttribute("data-fh-poll"), 10) || 0;
    if (ms <= 0) return;
    setTimeout(function () { check("poll", false).then(schedulePoll, schedulePoll); }, ms);
  }
  schedulePoll();
  document.addEventListener("visibilitychange", function () { if (!document.hidden) throttledCheck("visible"); });
  window.addEventListener("pageshow", function (e) { if (e.persisted) throttledCheck("pageshow"); });
  window.addEventListener("online", function () { throttledCheck("online"); });
  setTimeout(function () { check("load", true); }, 600);

  window.__fh = { check: check, root: function () { return root; }, log: function () { return log.slice(); }, lastCheck: function () { return lastCheck; }, version: "2" };
})();
